import PropTypes from 'prop-types';
import React from 'react';
import ReactModal from 'react-modal';

import styles from './auth-forms.css';

class ShareLinkModal extends React.Component {
    constructor (props) {
        super(props);
        this.state = {copied: false};
        this.handleCopy = this.handleCopy.bind(this);
    }
    componentDidUpdate (prevProps) {
        if (this.props.isOpen && !prevProps.isOpen) {
            this.setState({copied: false});
        }
    }
    handleCopy () {
        const link = this.props.link;
        if (!link) return;
        const done = () => this.setState({copied: true});
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(link).then(done).catch(() => {
                this.fallbackCopy(link);
                done();
            });
        } else {
            this.fallbackCopy(link);
            done();
        }
    }
    fallbackCopy (text) {
        const el = document.createElement('textarea');
        el.value = text;
        document.body.appendChild(el);
        el.select();
        try {
            document.execCommand('copy');
        } catch (e) {
            // ignore
        }
        document.body.removeChild(el);
    }
    render () {
        return (
            <ReactModal
                isOpen={this.props.isOpen}
                className={styles.modal}
                overlayClassName={styles.overlay}
                onRequestClose={this.props.onClose}
                contentLabel="Ссылка на проект"
            >
                <h2 className={styles.title}>Поделиться проектом</h2>
                <p className={styles.hint}>
                    Проект станет публичным. Отправьте ссылку — по ней откроется просмотр игры.
                </p>
                <label className={styles.label}>
                    Ссылка
                    <input
                        className={styles.input}
                        readOnly
                        type="text"
                        value={this.props.link || ''}
                        onFocus={e => e.target.select()}
                    />
                </label>
                <div className={styles.row}>
                    <button className={styles.button} type="button" onClick={this.handleCopy}>
                        {this.state.copied ? 'Скопировано' : 'Копировать'}
                    </button>
                    <a
                        className={styles.buttonSecondary}
                        href={this.props.link || '#'}
                        rel="noopener noreferrer"
                        target="_blank"
                        onClick={e => {
                            if (!this.props.link) e.preventDefault();
                        }}
                    >
                        Открыть
                    </a>
                    <button className={styles.buttonSecondary} type="button" onClick={this.props.onClose}>
                        Закрыть
                    </button>
                </div>
            </ReactModal>
        );
    }
}

ShareLinkModal.propTypes = {
    isOpen: PropTypes.bool,
    link: PropTypes.string,
    onClose: PropTypes.func.isRequired
};

export default ShareLinkModal;
